import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import AssociateContactToThreadButton from '../AssociateContactToThreadButton';
import CompanyName from 'svh-workspace-ui-lib/ticket-header/public/CompanyName';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledFormattedMessageAt = styled(FormattedMessage).withConfig({
  displayName: "CompanyDetails__StyledFormattedMessageAt",
  componentId: "sc-1bdiyf8-0"
})(["padding-right:4px;padding-left:4px;"]);
const StyledFormattedMessageFrom = styled(FormattedMessage).withConfig({
  displayName: "CompanyDetails__StyledFormattedMessageFrom",
  componentId: "sc-1bdiyf8-1"
})(["padding-right:4px;"]);
const StyledUIFlex = styled(UIFlex)(props => ({
  maxWidth: props.companyLink ? '' : '400px'
}));
const DisplayDetails = ({
  associatedCompanyId,
  jobTitle,
  company,
  companyLink
}) => {
  if (jobTitle && company) {
    return /*#__PURE__*/_jsxs(StyledUIFlex, {
      companyLink: companyLink,
      children: [/*#__PURE__*/_jsx("span", {
        children: jobTitle
      }), /*#__PURE__*/_jsx(StyledFormattedMessageAt, {
        message: "conversations-inbox-ui.header.atLabel"
      }), /*#__PURE__*/_jsx(CompanyName, {
        associatedCompanyId: associatedCompanyId,
        companyName: company,
        companyLink: companyLink
      })]
    });
  } else if (!jobTitle && company) {
    return /*#__PURE__*/_jsxs(StyledUIFlex, {
      companyLink: companyLink,
      children: [/*#__PURE__*/_jsx(StyledFormattedMessageFrom, {
        message: "conversations-inbox-ui.header.fromLabel"
      }), /*#__PURE__*/_jsx(CompanyName, {
        associatedCompanyId: associatedCompanyId,
        companyName: company,
        companyLink: companyLink
      })]
    });
  } else if (jobTitle && !company) {
    return /*#__PURE__*/_jsx("span", {
      children: jobTitle
    });
  }
  return null;
};
const CompanyDetails = ({
  associatedCompanyId,
  jobTitle,
  company,
  companyLink,
  isKnownContact,
  threadId
}) => {
  return /*#__PURE__*/_jsx(UIFlex, {
    style: {
      maxWidth: 'max-content'
    },
    children: isKnownContact ? /*#__PURE__*/_jsx(DisplayDetails, {
      associatedCompanyId: associatedCompanyId,
      jobTitle: jobTitle,
      company: company,
      companyLink: companyLink
    }) : /*#__PURE__*/_jsx(AssociateContactToThreadButton, {
      threadId: threadId
    })
  });
};
CompanyDetails.displayName = 'CompanyDetails';
DisplayDetails.displayName = 'DisplayDetails';
export default CompanyDetails;